export type CustomButton = { name: string; href: string }

// React twin of ApplicationHelper#render_button; props come from CustomButton.props_for.
export default function CustomButtons({ buttons, className }: { buttons: CustomButton[]; className?: string }) {
  return (
    <>
      {buttons.map((b, i) => (
        <span key={b.href}>
          {i > 0 && ', '}
          <a className={className} href={b.href} target="_blank" rel="noopener">
            {b.name}
          </a>
        </span>
      ))}
    </>
  )
}
